import {
    useMutation,
    useQueryClient,
  } from "@tanstack/react-query";
  import { useCallback, useState } from "react";
  import { useAuth0 } from "@auth0/auth0-react";
  import useAppContextProvider from "../../AppContext/useAppContextProvider";
  import { MoveDGMember } from "../../api/api";
  
  type MoveDGMemberResult = {
    status: string;
    Msg?: string;
    errorCode?: string;
  };
  
  type MoveDGMemberInput = {
    serials: string[];
    sourceSite: string;
    sourceGroup?: string;
    destinationSite: string;
    destinationgroup: string;
    filter: Object;
  };
  
  export const useMoveDGMember = () => {
    const queryClient = useQueryClient();
    const { setToastMessage, setToastOpen } =
      useAppContextProvider();
    const { getAccessTokenSilently } = useAuth0();
  
    const mutation = useMutation({
      mutationFn: ({
        serials,
        sourceSite,
        sourceGroup,
        destinationSite,
        destinationgroup,
        filter,
        token,
      }: MoveDGMemberInput & {
        token: string;
      }): Promise<MoveDGMemberResult> =>
        MoveDGMember(token, {
          serials,
          sourceSite,
          sourceGroup,
          destinationSite,
          destinationgroup,
          filter,
        }),
  
      onSuccess: (data) => {
        if (data.status === "error") {
          setToastMessage(
            `Error code: ${data.errorCode}, Error msg: ${data.Msg}` ||
              `Error moving miners`
          );
        } else {
          setToastMessage(
            "Miners have been moved successfully to the new group and site"
          );
        }
        setToastOpen(true);
      },
  
      onError: (error) => {
        console.error("Error moving miners:", error);
        setToastMessage("Error moving miners");
        setToastOpen(true);
      },
    });
  
    const mutateWithToken = useCallback(
      async (
        {
          serials,
          sourceSite,
          sourceGroup,
          destinationSite,
          destinationgroup,
          filter,
        }: MoveDGMemberInput,
  
        options?: {
          onSuccess?: (data: MoveDGMemberResult) => void;
          onError?: (error: any) => void;
          onSettled?: () => void;
        }
      ) => {
        const token = await getAccessTokenSilently();
  
        mutation.mutate(
          {
            serials,
            sourceSite,
            sourceGroup,
            destinationSite,
            destinationgroup,
            filter,
            token,
          },
          {
            onSuccess: options?.onSuccess,
            onError: options?.onError,
            onSettled: options?.onSettled,
          }
        );
      },
      [getAccessTokenSilently, mutation]
    );
  
    return { ...mutation, mutate: mutateWithToken };
  };